import {
  call, put, select, all,
} from 'redux-saga/effects';
import { apiGetDashs, apiGetInvoices, apiGetPaymentTickets } from 'services/api/dashs';
import { getErrorMessage } from 'utils/filters';
import { getCompany } from '../ducks/auth';
import { Creators as DashCreatores } from '../ducks/dash';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';

export function* getDashsInfo() {
  try {
    yield put(UiCreators.showLoader('DASH'));
    const company = yield select(getCompany);
    const data = yield call(apiGetDashs, company.id);
    yield put(UiCreators.hideLoader('DASH'));
    yield put(DashCreatores.getDashSuccess(data));
  } catch (error) {
    yield put(UiCreators.hideLoader('DASH'));
  }
}

const fileName = 'sagas/dash';

export function* getInvoicesDash({ payload }) {
  const { position, positionFilter } = payload;
  try {
    yield put(UiCreators.showLoader('INVOICE_LIST'));

    const company = yield select(getCompany);
    const data = yield call(apiGetInvoices, company.id, payload);

    yield all([
      put(DashCreatores.getInvoiceDashSuccess({ ...data, position, positionFilter })),
      put(UiCreators.hideLoader('INVOICE_LIST')),
    ]);
  } catch (err) {
    const message = getErrorMessage(err);
    yield all([
      put(UiCreators.growl(message, growlTypes.GROWL_ERROR, { err, method: `${fileName}/getInvoicesDash` })),
      put(UiCreators.hideLoader('INVOICE_LIST')),
    ]);
  }
}

export function* getPaymentTicketsDash({ payload }) {
  const { position, positionFilter } = payload;
  try {
    yield put(UiCreators.showLoader('PAYMENT_TICKET_LIST'));

    const company = yield select(getCompany);
    const data = yield call(apiGetPaymentTickets, company.id, payload);

    yield all([
      put(DashCreatores.getPaymentRequestDashSuccess({ ...data, position, positionFilter })),
      put(UiCreators.hideLoader('PAYMENT_TICKET_LIST')),
    ]);
  } catch (err) {
    const message = getErrorMessage(err);
    yield all([
      put(UiCreators.growl(message, growlTypes.GROWL_ERROR, { err, method: `${fileName}/getPaymentTicketsDash` })),
      put(UiCreators.hideLoader('PAYMENT_TICKET_LIST')),
    ]);
  }
}
